import React from 'react';
import PropTypes from 'prop-types';
import { RefreshArrowIcon, CloseIcon } from 'components';
import { convertFileSize } from 'utils/files/convertFileSize';
import classnames from 'classnames';

import './files-list.scss';

export class FilesList extends React.Component {
  static propTypes = {
    items: PropTypes.array,
    deleteItem: PropTypes.func,
    reloadItem: PropTypes.func,
    networkErrorMessage: PropTypes.string,
  };

  static defaultProps = {
    items: [],
    deleteItem: () => {},
    reloadItem: () => {},
    networkErrorMessage: '',
  };

  renderItem = (item = {}, index) => {
    const { deleteItem, reloadItem, networkErrorMessage } = this.props;
    const { fileName, fileSize, status, loaded, errorMessage } = item;

    let rightContent = '';

    switch (status) {
      case 'LOAD':
        rightContent = `${convertFileSize(loaded)} / ${convertFileSize(
          fileSize,
        )}`;
        break;
      case 'LOAD_PENDING':
        rightContent = `0 / ${convertFileSize(fileSize)}`;
        break;
      case 'ERROR':
        rightContent = errorMessage;
        break;
      case 'COMPLETE':
        rightContent = `${convertFileSize(fileSize)}`;
        break;
      default:
        return false;
    }

    return (
      <li
        key={index}
        className={classnames('files-list__file', {
          _error: status === 'ERROR',
        })}
      >
        <div className="files-list__name">{fileName}</div>
        <div className="files-list__right-panel">
          <div style={{ fontSize: status === 'ERROR' ? '10px' : '12px' }}>
            {rightContent}
          </div>
          <div className="files-list__refresh-arrow-container">
            {status === 'ERROR' && errorMessage === networkErrorMessage && (
              <RefreshArrowIcon
                width="15px"
                height="13px"
                onClick={() => reloadItem(item)}
              />
            )}
          </div>
          <CloseIcon
            width="11px"
            height="11px"
            onClick={() => deleteItem(item)}
          />
        </div>
      </li>
    );
  };

  render() {
    const { items = [] } = this.props;
    return <ul className="files-list">{items.map(this.renderItem)}</ul>;
  }
}
